import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { MarkdownView } from './MarkdownRenderer';

const UserAgreementModal = ({ show, onAccept, onDecline }) => {
  return (
    <Modal show={show} onHide={onDecline} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>User Agreement & Terms of Service</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <div className="page-content">
          <MarkdownView path="/TERMS_OF_USE.md" />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onDecline}>
          Decline
        </Button>
        <Button variant="primary" onClick={onAccept}>
          I Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserAgreementModal;
